<div class="flex items-center justify-start {{mainClass()}}">
  <i class="icon icon_Cstroke {{iconClass()}}"></i>
  <span class="{{valueClass()}}">{{value() | number: convertDigits()}}</span> 
</div>
